/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Choosetheplanforyourbusiness5Inputs */

const en_choosetheplanforyourbusiness5 = /** @type {(inputs: Choosetheplanforyourbusiness5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the right plan for your business`)
};

const de_choosetheplanforyourbusiness5 = /** @type {(inputs: Choosetheplanforyourbusiness5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle den passenden Plan für dein Business`)
};

/**
* | output |
* | --- |
* | "Choose the right plan for your business" |
*
* @param {Choosetheplanforyourbusiness5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const choosetheplanforyourbusiness5 = /** @type {((inputs?: Choosetheplanforyourbusiness5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Choosetheplanforyourbusiness5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_choosetheplanforyourbusiness5(inputs)
	return de_choosetheplanforyourbusiness5(inputs)
});
export { choosetheplanforyourbusiness5 as "chooseThePlanForYourBusiness" }